import { render, staticRenderFns } from "./InfoTableBooking.vue?vue&type=template&id=081ed56a&"
import script from "./InfoTableBooking.vue?vue&type=script&lang=js&"
export * from "./InfoTableBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports